module.exports = __webpack_public_path__ + "static/media/leave_group.4dd4ae6e.svg";